import { Instagram, Facebook } from 'lucide-react';

interface SocialLinksProps {
  size?: 'sm' | 'md';
}

/** Social media icon links (Instagram, Facebook) */
export function SocialLinks({ size = 'sm' }: SocialLinksProps) {
  const iconClass = size === 'md' ? 'w-6 h-6' : 'w-5 h-5';
  const containerClass = size === 'md' ? 'p-2' : '';

  return (
    <>
      <a
        href="https://www.instagram.com/jmefit_/"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-[#E1306C] hover:text-[#C13584] transition-all duration-300 transform hover:scale-110 hover:rotate-3 ${containerClass}`}
        aria-label="Follow JMEFit on Instagram"
      >
        <Instagram className={iconClass} />
      </a>
      <a
        href="https://facebook.com/jmefit"
        target="_blank"
        rel="noopener noreferrer"
        className={`text-[#1877F2] hover:text-[#166FE5] transition-all duration-300 transform hover:scale-110 hover:rotate-3 ${containerClass}`}
        aria-label="Follow JMEFit on Facebook"
      >
        <Facebook className={iconClass} />
      </a>
    </>
  );
}
